import React from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";

const Project = ({ item }) => {
  AOS.init();
  return (
    <div key={item.id} className='flex flex-col  items-center text-center' data-aos='zoom-in'>
      <div className='mb-8 group relative'>
        <img className='rounded-2xl w-full object-cover' src={item.image} alt='' />
        <div
            class="absolute rounded-2xl top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-accent opacity-0 group-hover:h-full group-hover:opacity-100 duration-500">
            <h3 className='text-2xl text-primary font-semibold capitalize mb-3'>{item.name}</h3>
            <p className='text-base text-primary max-w-md'>{item.description}</p>
            <div className='flex space-x-28 content-end'>
            <a className='text-base flex justify-between' href={item.href}>
              {item.icon}
            </a>
            <a className='text-base flex justify-between' href={item.href1}>
              {item.icon1}
            </a>
            </div>
        </div>
      </div>
      <div>
      <p className='capitalize justify-between space-x-3 flex text-accent text-xl mb-3'>
      {item.icon3}{item.icon4}{item.icon5}{item.icon6}{item.icon7}
      {item.icon8}
      </p>
      </div>
    </div>
  );
};

export default Project;
